'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regionAlign = require('@zippytech/region-align');

var _regionAlign2 = _interopRequireDefault(_regionAlign);

var _selectParent = require('../../common/selectParent');

var _selectParent2 = _interopRequireDefault(_selectParent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function getRegionRelativeToParent(child, prentClassName) {
  var parent = (0, _selectParent2.default)('.' + prentClassName, child);
  var menuRegion = _regionAlign2.default.from(parent);
  var thisRegion = _regionAlign2.default.from(child);
  return {
    left: thisRegion.left - menuRegion.left,
    top: thisRegion.top - menuRegion.top,
    width: thisRegion.width,
    height: thisRegion.height
  };
}

exports.default = getRegionRelativeToParent;